<template>
    <!-- 
				Card - About
    -->
    <div class="card-inner animated active" id="about-card">
        <div class="card-wrap">
            <!-- 
						About 
            -->
            <div class="content about">
                <!-- title -->
                <div class="title">
                    {{$t("aboutMe.002")}}
                    <span class="subtitle fz-rem5">({{$t("aboutMe.002_01")}})</span>
                </div>

                <!-- content -->
                <div class="row">
                    <div class="col col-d-12 col-t-12 col-m-12 border-line-v">
                        <div class="text-box">
                            <b>
                                <pre style="font-size:16px;">
{{$t("aboutMe.001")}}
                                </pre>
                            </b>
                        </div>
                        <div class="info-list">
                            <ul>
                                <li v-for="(item, index) in infoList" :key="index">
                                    <strong>{{item.name}} . . . . .</strong>
                                    {{item.value}}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

            <!--
						Services
            -->
            <div class="content services">
                <!-- title -->
                <div class="title">{{$t("aboutMe.003")}}</div>

                <!-- content -->
                <div class="row service-items border-line-v">
                    <!-- service item -->
                    <template v-for="(service, index) in serviceList">
                        <div :key="index" class="col col-d-6 col-t-6 col-m-12 border-line-h">
                            <div class="service-item">
                                <div class="icon">
                                    <span :class="service.icon"></span>
                                </div>
                                <h1 class="name">{{service.name}}</h1>
                                <ul>
                                    <template v-for="(item, index) in service.list">
                                        <li :key="index" class>
                                            <b>{{item.name}} :</b>
                                            <br />
                                            {{item.des}}
                                        </li>
                                        <br :key="'br'+index" />
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </template>
                    <div class="clear"></div>
                </div>
            </div>

            <!--
						Fun Fact
            -->
            <div class="content fuct">
                <!-- title -->
                <div class="title">{{$t("aboutMe.004")}}</div>
                <!-- content -->
                <div class="row fuct-items">
                    <!-- fuct item -->
                    <div v-for="(fuct, index) in fuctList" :key="index" class="col col-d-3 col-t-3 col-m-6 border-line-v">
                        <div class="fuct-item">
                            <div class="icon">
                                <span :class="fuct.icon"></span>
                            </div>
                            <div class="name" v-html="fuct.nameHtml"></div>
                        </div>
                    </div>

                    <div @click="$router.push('/Resume')" class="col col-d-3 col-t-3 col-m-6 border-line-v">
                        <div class="fuct-item">
                            <div class="icon">
                                <span class="fas fa-angle-double-right"></span>
                            </div>
                            <div class="name">{{$t("aboutMe.005")}}...</div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

            <!--
						Clients
            -->
            <div class="content clients">
                <!-- title -->
                <div class="title">{{$t("aboutMe.006")}}</div>

                <!-- content -->
                <div class="row client-items">
                    <!-- client item -->
                    <div v-for="(client, index) in clientList" :key="index" class="col col-d-3 col-t-3 col-m-6 border-line-v">
                        <div class="client-item">
                            <div class="image">
                                <img :src="client" alt />
                            </div>
                        </div>
                    </div>

                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {},
    computed: {
        infoList() {
            return [
                { name: this.$t("aboutMe.007"), value: this.$t("aboutMe.011") },
                { name: this.$t("aboutMe.008"), value: this.$t("aboutMe.012") },
                { name: this.$t("aboutMe.009"), value: this.$t("aboutMe.013") },
                { name: this.$t("aboutMe.010"), value: this.$t("aboutMe.014") }
            ];
        },
        serviceList() {
            return [
                {
                    name: this.$t("aboutMe.015"),
                    icon: "far fa-window-restore",
                    list: [
                        { name: this.$t("aboutMe.016"), des: this.$t("aboutMe.017") },
                        { name: this.$t("aboutMe.018"), des: this.$t("aboutMe.019") },
                        { name: this.$t("aboutMe.020"), des: this.$t("aboutMe.021") },
                        { name: this.$t("aboutMe.022"), des: this.$t("aboutMe.023") }
                    ]
                },
                {
                    name: this.$t("aboutMe.024"),
                    icon: "fas fa-laptop",
                    list: [
                        {
                            name: this.$t("aboutMe.025"),
                            des: this.$t("aboutMe.026")
                        },
                        { name: this.$t("aboutMe.027"), des: this.$t("aboutMe.028") },
                        { name: this.$t("aboutMe.029"), des: this.$t("aboutMe.030") },
                        { name: this.$t("aboutMe.031"), des: this.$t("aboutMe.032") }
                    ]
                },
                {
                    name: this.$t("aboutMe.033"),
                    icon: "fas fa-server",
                    list: [
                        { name: this.$t("aboutMe.034"), des: this.$t("aboutMe.035") },
                        {
                            name: this.$t("aboutMe.036"),
                            des: this.$t("aboutMe.037")
                        }
                    ]
                },
                {
                    name: this.$t("aboutMe.038"),
                    icon: "fas fa-people-carry",
                    list: [
                        { name: this.$t("aboutMe.039"), des: this.$t("aboutMe.040") },
                        {
                            name: this.$t("aboutMe.041"),
                            des: this.$t("aboutMe.042")
                        },
                        { name: this.$t("aboutMe.043"), des: this.$t("aboutMe.044") }
                    ]
                }
            ];
        },
        fuctList() {
            return [
                { nameHtml: this.$t("aboutMe.045"), icon: "fas fa-graduation-cap" },
                { nameHtml: this.$t("aboutMe.046"), icon: "fas fa-code" },
                { nameHtml: this.$t("aboutMe.047"), icon: "fas fa-user-plus" }
            ];
        },
        clientList() {
            return [
                require("@/assets/images/clients/vue.png"),
                require("@/assets/images/clients/git-icon.png"),
                require("@/assets/images/clients/javaEE.png"),
                require("@/assets/images/clients/scss.png")
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/AboutMe.vue